module.exports = __webpack_public_path__ + "img/compliance-img.fdf8af3c.jpg";